<template>
<div class="page_shopCenter page_agent">
    <div class="userInfo">
        <div class="user">
            <div class="user_top">
                <div class="user_left">
                    <div class="thumb">
						<van-image class="thumb" :src="info.thumb? ($publicData.withHttpStart(info.thumb) ? info.thumb : imageUrl+info.thumb) : $publicData.defaultTouxiang" fit="cover" :show-loading="false" :show-error="false" />
                    </div>
                    <div class="user_name slh_s">{{ info.name }}</div>
                </div>
                <div class="user_right">余额:￥{{ info.money ? info.money : 0}}</div>
            </div>
        </div>
    </div>
    <!-- 平台服务 -->
    <ul class="agent_list">
        <li class="item" @click="goPage('agent-income')">
            <div class="item_l">
                <img :src="publicPath+'statics/images/icon_income.png'" alt="" class="icon">
                <span class="">收入明细</span>
            </div>
        </li>
        <li class="item" @click="goWithdraw('/agent/withdraw')">
            <div class="item_l">
                <img :src="publicPath+'statics/images/icon_tixian.png'" alt="" class="icon">
                <span class="">提现</span>
            </div>
        </li>
        <li class="item" @click="goPage('agent-withdrawList')">
            <div class="item_l tixianlist">
                <img :src="publicPath+'statics/images/icon_tixianlist.png'" alt="" class="icon">
                <span class="">提现明细</span>
            </div>
        </li>
        <li class="item" @click="goPage('bank-index')">
            <div class="item_l bank">
                <img :src="publicPath+'statics/images/icon_bank.png'" alt="" class="icon">
                <span class="">银行卡管理</span>
            </div>
        </li>
		<!-- 一级代理商没有 查看会员、商家二维码 -->
        <li class="item" @click="goPage('agent-member')" v-if="agent_level == 2">
            <div class="item_l member">
                <img :src="publicPath+'statics/images/icon_member.png'" alt="" class="icon">
                <span class="">查看会员</span>
            </div>
        </li>
        <!-- <li class="item" @click="goPage('agent-qrcode')" v-if="agent_level == 2">
            <div class="item_l qrcode">
                <img :src="publicPath+'statics/images/icon_qrcode.png'" alt="" class="icon">
                <span class="">二维码</span>
            </div>
        </li> -->
		<!-- 一级分销商 查看业务员 -->
		<li class="item"  v-if="agent_level == 1" @click="toSalesman">
            <div class="item_l member">
                <img :src="publicPath+'statics/images/icon_member.png'" alt="" class="icon">
                <span class="">业务员管理</span>
            </div>
        </li>
		<!-- 二级分销商 海报 -->
		<li class="item" v-if="agent_level == 2" @click="goPage('agent-qrcode')">
            <div class="item_l member">
                <img :src="publicPath+'statics/images/icon_sendimage.png'" alt="" class="icon">
                <span class="">海报</span>
            </div>
        </li>
		<!-- 二级分销商 二维码-->
		<li class="item" v-if="agent_level == 2" @click="toAllqrcodes">
            <div class="item_l member">
                <img :src="publicPath+'statics/images/icon_qrcode.png'" alt="" class="icon">
                <span class="">二维码</span>
            </div>
        </li>
    </ul>
	<!-- 二级分销 -->
    <div class="con" v-if="agent_level == 2">
        <!-- 我的商家 -->
        <div class="list" v-if="tradesmanList">
            <div class="title">
                <span class="title_l">分销商家</span>
                <span class="title_r" @click="goPage('agent-tradesman')">查看更多</span>
            </div>
            <ul class="list_con clearfix">
                <li class="item f-l" v-for="tradesman in tradesmanList" :key="tradesman.id" @click="toPush(tradesman)">
					<van-image class="icon" fit="cover" :src="tradesman.thumb ? ( $publicData.withHttpStart(tradesman.thumb)? tradesman.thumb :imageUrl+tradesman.thumb ) : $publicData.defaultTouxiang" :show-error="false" :show-loading="false" />
                    <div class="txt">{{ tradesman.nickname.slice(0,5)+'...' }}</div>
                </li>
            </ul>
        </div>
        <!-- 城市合伙人 分销商都没有城市合伙人了-->
        <!-- <div class="list" v-if="partner">
            <div class="title">城市合伙人</div>
            <ul class="list_con clearfix">
                <li class="item f-l">
                    <img :src="partner.thumb ? partner.thumb : $publicData.defaultTouxiang" alt="" class="icon">
                    <div class="txt">{{ partner.name }}</div>
                </li>
            </ul>
        </div> -->
    </div>
	<!-- 一级分销 -->
	<div class="con" v-if="agent_level == 1">
        <!-- 我的二级分销商 -->
        <div class="list" v-if="agentList">
            <div class="title">
                <span class="title_l">我的二级分销商</span>
                <span class="title_r" @click="goSecondAgent">查看更多</span>
            </div>
            <ul class="list_con clearfix">
                <li class="item f-l" v-for="agent in agentList" :key="agent.agent_uuid">
					<van-image class="icon" fit="cover" :src="agent.company_photo ? ( $publicData.withHttpStart(agent.company_photo) ? agent.company_photo :imageUrl+agent.company_photo) : $publicData.defaultTouxiang" :show-error="false" :show-loading="false" />
                    <div class="txt">{{ agent.nickname.slice(0,5)+'...' }}</div>
                </li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
            ordertab: 'a',
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
            tradesmanList: [], //商户列表
            partner: null,
            token: null,
			imageUrl: this.$publicData.uploadImage,
			agent_level: this.$route.query.agent_level, // 1 一级分销, 2 二级分销
			agentList: []
        };
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "分销商首页"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    mounted: function () {

    },
    methods: {
        getData() {
            var param = {
				token: this.token,
				page: 1,
				size: 10
			}
			if(this.agent_level == 2){
				this.$api.my.agentIndex(param).then(res => {
					if (res.code == 200) {
						this.info = res.result.info
						let list = res.result.tradesman
						// 商家取前4个
						if (list.length > 4) {
							this.tradesmanList = list.slice(0, 4)
						} else {
							this.tradesmanList = list
						}
						if(res.result.partner.have == 1) {
							this.partner = res.result.partner.partner
						}
					} else {
						this.$toast(res.message)
					}
				})
			}else if(this.agent_level == 1){
				this.$api.my.firstAgentIndex(param).then(res => {
					if (res.code == 200) {
						this.info = res.result.info
						var list = res.result.agent
						// 我的二级代理商去前4个
						if (list.length > 4) {
							this.agentList = list.slice(0, 4)
						} else {
							this.agentList = list
						}
						// if(res.result.partner.have == 1) {
						// 	this.partner = res.result.partner.partner
						// }
					} else {
						this.$toast(res.message)
					}
				})
			}
            
        },
		/**
		 * @name: 跳转至二维码
		 * @return {*}
		 * @desc: 
		 */		
		toAllqrcodes(){
			this.$router.push({
				path: '/agent/allqrcodes',
				query: {
					uuid: this.info.agent_uuid
				}
			})
		},
        // 页面跳转
        goPage(name) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        name = name.replace("-", "/")
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/' + name
                            }
                        }
                        // console.log(params)
                        // console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
                    this.$router.push({
                        path: '/login',
                        query: {
                            redirect: this.$router.currentRoute.fullPath
                        }
                    })
                    return
                }
                this.$router.push({
                    name: name
                })
            }
        },
        // 提现
        goWithdraw(path) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var url = this.$publicData.clientUrl + path + '?price='+(this.info.money ? this.info.money : '0')+'&type=4'
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + path
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                var query = {
                    price: this.info.money ? this.info.money : 0,
                    type: 4
                }
                this.$router.push({
                    path: path,
                    query: query
                })
            }
		},
		// 我的二级分销商
		goSecondAgent(){
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var url = this.$publicData.clientUrl + '/my/second/agent'
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + path
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: '/my/second/agent'
                })
            }
			
		},
		/**
		 * @name: 推送
		 * @param {*} item
		 * @return {*}
		 * @desc: 
		 */		
		toPush(item){
			this.$router.push({
				path: '/agent/tradesman/push',
				query: {
					trad_uuid: item.tradesman_uuid,
					is_push: item.is_push,
					nickname: item.nickname,
					thumb: item.thumb,
					sort: item.sort
				}
			})
		},
		/**
		 * @name: 跳转业务员
		 * @return {*}
		 * @desc: 
		 */		
		toSalesman(){
			this.$router.push({
				path: '/agent/salesman',
				query: {
					first_agent_uuid: this.info.agent_uuid
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
